"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import 'react';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';
import '../../../../lib/propsContext/propsContext.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import '@react-aria/utils';
import 'remeda';
import 'dot-prop';

const MenuTrigger = flowComponent(
  "MenuTrigger",
  (props) => {
    return /* @__PURE__ */ jsx(Aria.MenuTrigger, { ...props });
  }
);

export { MenuTrigger, MenuTrigger as default };
//# sourceMappingURL=MenuTrigger.mjs.map
